<mng-dialog-header [title]="data.hotel.name" [subTitle]="data.hotel.adresse" />

<google-map class="geo-map-dialog" [options]="options">
  <map-marker #marker="mapMarker" [position]="markerPosition" (mapClick)="clickMarker(marker)" />
  <map-info-window>
    <strong>{{ data.hotel.name }}</strong>

    <mng-out label="Adresse">
      <div class="text-accent">{{ data.hotel.adresse }}</div>
    </mng-out>

    @if (data.hotel.homepage) {
      <mng-out label="Homepage">
        <a target="_blank" [href]="data.hotel.homepage">{{ data.hotel.homepage }}</a>
      </mng-out>
    }

    @if (data.hotel.telefon) {
      <mng-out label="Telefon">
        <a href="tel:{{ data.hotel.telefon }}">{{ data.hotel.telefon }}</a>
      </mng-out>
    }
  </map-info-window>
</google-map>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" mat-dialog-close>Schliessen</button>
</mat-dialog-actions>
